import { RejectedWithValueActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { asyncPayloadCreator } from './asyncPayloadCreator';

export async function downloadDocuments<T>(data: T, fileName: string, apiCall: (arg0: T) => any) {
	const result = await apiCall(data);
	const file = new Blob([result as unknown as BlobPart]);
	const fileURL = URL.createObjectURL(file);
	const link = document.createElement('a');
	link.download = fileName;
	link.href = fileURL;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

/**
 * Merged version of {@linkcode downloadDocuments} & {@linkcode asyncPayloadCreator}
 */
export async function downloadDocumentsWithAsyncPayloadCreator<T>(
	data: T,
	rejectWithValue: (value: unknown) => RejectedWithValueActionFromAsyncThunk<any>,
	fileName: string,
	apiCall: (arg0: T) => any,
) {
	try {
		const result = await apiCall(data);
		const file = new Blob([result as unknown as BlobPart]);
		const fileURL = URL.createObjectURL(file);
		const link = document.createElement('a');
		link.download = fileName;
		link.href = fileURL;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} catch (e: any) {
		return rejectWithValue(e?.response.data);
	}
}
